import React, { useState, useEffect } from 'react';
import CustomInput from '../../Utility/Components/CustomInput';
import ErrorBoundary from '../../Utility/Components/ErrorBoundary';
import { walinerSettingPatch, walinerSettingPost } from '../Controller/OrganizationController';
import Utility from "../../Utility/Utility";


function WalinerConfigModalContent(props) {
    console.log("the props are: ", props);
    console.log("formData: ", props.formData);
    const [formData, setFormData] = useState({
        whatsapp_phonenumber_id: "",
        text_message_url: "",
        template_message_url: "",
        message_token: ""
    });

    const [errorFormData, setErrorFormData] = useState({
        whatsapp_phonenumber_id: "",
        text_message_url: "",
        template_message_url: "",
        message_token: ""
    });
    const [isExistingRecord, setIsExistingRecord] = useState(false);
    const [existingId, setExistingId] = useState(null);

    useEffect(() => {
        const data = props.formData?.data?.[0]?.WalinerConfiguration_data;
        if (data && data.length > 0) {
            const orgRecord = data.find(item => item.org_id === props.orgId);
            const defaultRecord = data.find(item => item.org_id === 0);
            const src = orgRecord || defaultRecord;
            if (src) {
                setFormData({
                    whatsapp_phonenumber_id: orgRecord ? (src.whatsapp_phonenumber_id || "") : "",
                    text_message_url: orgRecord ? (src.text_message_url || "") : "",
                    template_message_url: orgRecord ? (src.template_message_url || "") : "",
                    message_token: orgRecord ? (src.message_token || "") : ""
                });
                setIsExistingRecord(!!orgRecord);
                setExistingId(orgRecord ? orgRecord.id : null);
            }
        }
    }, [props.formData]);

    const handleChange = (e, field) => {
        const value = e && e.target ? e.target.value : e;
        setFormData(prev => ({ ...prev, [field]: value }));
        setErrorFormData(prev => ({ ...prev, [field]: "" }));
    };

    const validate = () => {
        let valid = true;
        const errors = { whatsapp_phonenumber_id: "", text_message_url: "", template_message_url: "", message_token: "" };
        if (!formData.whatsapp_phonenumber_id.trim()) {
            errors.whatsapp_phonenumber_id = "Required Field";
            valid = false;
        }
        if (!formData.text_message_url.trim()) {
            errors.text_message_url = "Required Field";
            valid = false;
        }
        if (!formData.template_message_url.trim()) {
            errors.template_message_url = "Required Field";
            valid = false;
        }
        if (!formData.message_token.trim()) {
            errors.message_token = "Required Field";
            valid = false;
        }
        setErrorFormData(errors);
        return valid;
    };

    const handleSave = () => {
        if (!validate()) return;
        const { loaderStateTrue, loaderStateFalse, onClose } = props;
        if (loaderStateTrue) loaderStateTrue();
        if (isExistingRecord) {
            const trimmedData = Object.fromEntries(Object.entries(formData).map(([k, v]) => [k, typeof v === 'string' ? v.trim() : v]));
            const formatData = [{
                resource_name: "WalinerConfiguration",
                column_value_pair: [{ id: existingId, org_id: props.orgId, ...trimmedData }]
            }];
            walinerSettingPatch(null, formatData).then(res => {
                if (loaderStateFalse) loaderStateFalse();
                if (res && res[0].data[0].success) {
                    Utility.toastNotifications(res.message || "Updated successfully", "Success", "success");
                    if (onClose) onClose();
                } else {
                    Utility.toastNotifications(res?.message || "Update failed", "Error", "error");
                }
            }).catch(err => {
                if (loaderStateFalse) loaderStateFalse();
                Utility.toastNotifications(err?.message || "Something went wrong", "Error", "error");
            });
        } else {
            const trimmedData = Object.fromEntries(Object.entries(formData).map(([k, v]) => [k, typeof v === 'string' ? v.trim() : v]));
            const formatData = [{
                resource_name: "WalinerConfiguration",
                column_value_pair: [{ ...trimmedData, org_id: props.orgId }]
            }];
            walinerSettingPost(formatData).then(res => {
                console.log("res===>", res);
                if (loaderStateFalse) loaderStateFalse();
                if (res && res[0].success) {
                    Utility.toastNotifications(res.message || "Saved successfully", "Success", "success");
                    if (onClose) onClose();
                } else {
                    Utility.toastNotifications(res?.message || "Save failed", "Error", "error");
                }
            }).catch(err => {
                if (loaderStateFalse) loaderStateFalse();
                Utility.toastNotifications(err?.message || "Something went wrong", "Error", "error");
            });
        }
    };

    return (
        <div className="gridcontainer">
            <div className="modalinnerbody" style={{ marginRight: 10 }}>
                <div className="innerbodydimension">
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-6">
                                <ErrorBoundary title="CustomInput Error">
                                    <CustomInput
                                        parentClassName="input_field_inner"
                                        labelName="WhatsApp Phone Number ID"
                                        errorLabel={errorFormData.whatsapp_phonenumber_id}
                                        name="whatsapp_phonenumber_id"
                                        type="text"
                                        value={formData.whatsapp_phonenumber_id}
                                        labelPresent={true}
                                        requiredStar={true}
                                        onChange={(e) => handleChange(e, 'whatsapp_phonenumber_id')}
                                    />
                                </ErrorBoundary>
                            </div>
                            <div className="col-md-6">
                                <div className="input_field_inner">
                                    <label className="input_label input_label_color">
                                        Text Message URL <span className="requiredStart">*</span>
                                    </label>
                                    <textarea
                                        className="input__fields_property"
                                        rows={3}
                                        value={formData.text_message_url}
                                        onChange={(e) => handleChange(e, 'text_message_url')}
                                        style={{ width: '100%', resize: 'vertical', padding: '8px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '13px' }}
                                    />
                                    {errorFormData.text_message_url && (
                                        <div className="errorClass error_div">{errorFormData.text_message_url}</div>
                                    )}
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="input_field_inner">
                                    <label className="input_label input_label_color">
                                        Template Message URL <span className="requiredStart">*</span>
                                    </label>
                                    <textarea
                                        className="input__fields_property"
                                        rows={3}
                                        value={formData.template_message_url}
                                        onChange={(e) => handleChange(e, 'template_message_url')}
                                        style={{ width: '100%', resize: 'vertical', padding: '8px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '13px' }}
                                    />
                                    {errorFormData.template_message_url && (
                                        <div className="errorClass error_div">{errorFormData.template_message_url}</div>
                                    )}
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="input_field_inner">
                                    <label className="input_label input_label_color">
                                        Message Token <span className="requiredStart">*</span>
                                    </label>
                                    <textarea
                                        className="input__fields_property"
                                        rows={3}
                                        value={formData.message_token}
                                        onChange={(e) => handleChange(e, 'message_token')}
                                        style={{ width: '100%', resize: 'vertical', padding: '8px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '13px' }}
                                    />
                                    {errorFormData.message_token && (
                                        <div className="errorClass error_div">{errorFormData.message_token}</div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-12 text-center topspace">
                    <button type="button" className="modBtnSave" onClick={handleSave}>Save</button>
                    <button type="button" className="modBtnSave cancelbtn" onClick={props.onClose}>Cancel</button>
                </div>
            </div>
        </div>
    );
}

export default WalinerConfigModalContent;
